<template>
    <div>
        <div v-if="showHackGif" class="hack-gif">
            <h1 class="hack-heading">Hacking in progress ...</h1>
            <video class="hack-video" autoplay controls loop>
                <source :src="getHackerGif()" type="video/mp4" />
            </video>
        </div>
        <div v-if="hackEnabled" class="hack-mode-indicator">
            <div>Hack mode</div>
        </div>
    </div>
</template>

<script>
import MessageService from '~/services/MessageService';
import hackerman from '~/assets/video/hackerman.mp4';

export default {
    name: 'VFairHack',
    data() {
        return {
            showHackGif: false,
            hackClicked: false,
        };
    },
    computed: {
        hackEnabled() {
            return this.$interfaces.vfairModule.getHackEnabled();
        },
    },
    methods: {
        async listenerFunction(event) {
            if (event.altKey && event.ctrlKey && event.keyCode === 72 && !this.hackClicked) {
                console.log('key');
                this.hackClicked = true;
                if (this.hackEnabled) {
                    this.$interfaces.vfairModule.setHackEnabled(false);
                    MessageService.newMessage('Hack ended', 'Make sure to cover your tracks.');
                    setTimeout(() => {
                        this.hackClicked = false;
                    }, 2000);
                } else {
                    MessageService.newMessage(
                        'Hacking initialized',
                        'Accessing mainframe...',
                        3000
                    );
                    setTimeout(() => {
                        this.showHackGif = true;
                        setTimeout(() => {
                            this.$interfaces.vfairModule.setHackEnabled(true);
                            this.showHackGif = false;
                            MessageService.newMessage(
                                'Hack Complete',
                                'Access infinite free virtual events before its even begun!'
                            );
                            this.hackClicked = false;
                        }, 3000);
                    }, 3000);
                }
            }
        },
        initializeVFairHack() {
            // Easter Egg functionality. On Ctrl-Alt-H => Access vfairs closed.
            window.addEventListener('keydown', this.listenerFunction);
        },
        getHackerGif() {
            return hackerman;
        },
    },
    mounted() {
        this.initializeVFairHack();
    },
    destroyed() {
        window.removeEventListener('keydown', this.listenerFunction);
    },
};
</script>

<style>
.hack-gif {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: black;
    z-index: 10000;
    top: 0;
    display: flex;
    flex-direction: column;
}
.hack-video {
    width: 50%;
    margin: auto;
}
.hack-heading {
    color: darkblue;
    text-align: center;
}
.hack-mode-indicator {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: rgba(100, 100, 100, 0.2);
}
</style>
